import { createSlice } from "@reduxjs/toolkit";

const userFeatureSlice = createSlice({
    name: "userFeatures",
    initialState: {
        data: null,
    },
    reducers: {
        setUserFeature: (state, action) => {
            state.data = action.payload;
        },
    },
});
export const { setUserFeature } = userFeatureSlice.actions;
export default userFeatureSlice.reducer;

